import { Box, HStack, Text, VStack } from '@gluestack-ui/themed';
import { CheckIcon } from 'lucide-react-native';
import { useContext } from 'react';
import { TranslationContext } from '../../contexts/translations/Translation';
import { COLORS } from '../../theme/colors';

const STEPS = ['stepper.sample', 'stepper.detection', 'stepper.strain-ai', 'stepper.verification'];

interface IAnalysisStepperProps {
  currentStep: 0 | 1 | 2 | 3;
}

export const AnalysisStepper = ({ currentStep }: IAnalysisStepperProps) => {
  const { i18n } = useContext(TranslationContext);

  return (
    <HStack alignItems="center" justifyContent="center" marginBottom={24} flexWrap="wrap" gap={4}>
      {STEPS.map((labelKey, index) => {
        const isDone = index < currentStep;
        const isActive = index === currentStep;
        return (
          <HStack key={index} alignItems="center">
            <VStack alignItems="center" gap={4}>
              <Box
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 16,
                  borderWidth: 2,
                  borderColor: isDone || isActive ? (isDone ? COLORS.STATUS.SUCCESS : COLORS.ACCENT[100]) : COLORS.NEUTRAL[70],
                  backgroundColor: isDone ? COLORS.STATUS.SUCCESS : isActive ? COLORS.ACCENT[100] : 'transparent',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {isDone ? (
                  <CheckIcon size={16} color={COLORS.NEUTRAL[0]} />
                ) : (
                  <Text
                    fontWeight="bold"
                    fontSize={13}
                    color={isActive ? COLORS.NEUTRAL[0] : COLORS.NEUTRAL[70]}
                  >
                    {index + 1}
                  </Text>
                )}
              </Box>
              <Text
                fontSize={11}
                color={isActive ? COLORS.FOUNDATION_TERCIARY_100 : COLORS.NEUTRAL[90]}
                fontWeight={isActive ? 'bold' : 'normal'}
              >
                {i18n?.t(`page.analysis-details.${labelKey}`)}
              </Text>
            </VStack>
            {index < STEPS.length - 1 && (
              <Box
                style={{
                  height: 2,
                  width: 32,
                  backgroundColor: isDone ? COLORS.STATUS.SUCCESS : COLORS.NEUTRAL[70],
                  marginBottom: 18,
                  marginHorizontal: 4,
                }}
              />
            )}
          </HStack>
        );
      })}
    </HStack>
  );
};
